import React from 'react';
// import { NavLink } from 'react-router-dom';
import SidebarItem from "./sideBarItem";
import './sideMenu.scss'
import { connect } from 'react-redux';
import moment from 'moment/moment';
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../../config";
import useUser from '../../hooks/useUser';

const msalInstance = new PublicClientApplication(msalConfig);

function SideMenuMobile({ collapseMenu = () => { }, ...props }) {
    const { isAdmin } = useUser();

    let dates = props.contents?.items?.map((n) => n.sys.createdAt)
    let dateFilters = dates.reduce((acc, cur) => {

        let exist = false;

        acc.forEach(element => {
            if (element.title === moment(cur).format("MMMM YYYY")) {
                exist = true
            }
        });

        if (!exist) {
            acc.push({
                title: moment(cur).format("MMMM YYYY"),
                time: cur,
                path: "/" + moment(cur).format("MMM-YYYY").toLowerCase()
            })
        }

        return acc
    }, []);

    let items = [
        {
            "title": "Spaces",
            "icon": "/assets/vector-icons/home.svg",
            "children": dateFilters,
            "open": true,
            "path": "/"
        },
        {
            "title": "Apps",
            "icon": "/assets/vector-icons/people.svg",
            "children": [               
                {
                    "title": "Zoho CRM",
                    "link": "https://crm.zoho.com",
                    "external": true
                },
                {
                    "title": "Punch",
                    "link": "https://hcm-ae10.hr.cloud.sap/login?company=kinnarpspr",
                    "external": true
                },
                {
                    "title": "Procore",
                    "link": "https://login.procore.com/",
                    "external": true
                }, 
                {
                    "title": "Kunskap",
                    "link": "https://kps.litmoseu.com",
                    "external": true
                },
                ...(!isAdmin ? [
                    {
                        "title": "Pluto",
                        "link": "https://app.plutocard.io",
                        "external": true
                    }
                ] : []),
                ...(isAdmin ? [
                    {
                        "title": "Pluto",
                        "path": "/pluto"
                    },
                    {
                        "title": "Expenses",
                        "path": "/expenses"
                    }
                ] : [])
            ]
        }
        // {
        //     "title": "AI HR Assistant",
        //     "icon": "/assets/vector-icons/people.svg",
        //     "open": true,
        //     "path": "/ai-hr"
        // }
    ]

    const _baseClass = "sideMenu-mobile";
    const { collapsed } = props;

    const logout = async () => {
        await msalInstance.initialize()
        await msalInstance.handleRedirectPromise()
        msalInstance.clearCache();
        msalInstance.logoutRedirect();
    }
    return (
        <div className={_baseClass + (collapsed ? ' w-0' : ' w-full lg:w-[236px]') + " overflow-hidden transition-all border-[#F3EEF6] xl:border bg-white h-full fixed top-0 left-0 z-10 fixed"}>
            <div className='h-[70px] flex justify-center items-center'>

                {/* <NavLink to={"/"} onClick={closeMenu}>
                    <div className='font-sofia-sb text-[45px] text-[#1C355E] font-black uppercase'>Spaces</div>
                </NavLink> */}

            </div>

            <div className="sidebar">
                {items.map((item, index) => <SidebarItem key={index} item={item} collapseMenu={collapseMenu} />)}
            </div>
            <div onClick={logout} className="h-[50px] flex items-center justify-center w-full text-[#1c355e] bg-[#e7e7e8] cursor-pointer">
                Logout
            </div>

            {/* <div className={_baseClass + '-toggler'} onClick={() => { toggleCollapse(!collapsed) }}>
                {
                    collapsed
                        ?
                        <img src="/assets/vector-icons/arrow-right.svg" alt="" />
                        :
                        <img src="/assets/vector-icons/arrow-left.svg" alt="" />
                }
            </div> */}
        </div>
    );
}

const mapStateToProps = state => ({
    contents: state.contents
});

export default connect(mapStateToProps)(SideMenuMobile);
